module.exports = __webpack_public_path__ + "img/050-world-grid.eac46878.svg";